export default {
  formatNumber(value?: number | null) {
    return value ? +value.toFixed(2) : 0;
  },
  trunkNumber(value?: number | null) {
    return value ? Math.trunc(value) : 0;
  },
};
